import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { WebsterChatArea } from '@/components/webster/WebsterChatArea';
import { WebsterChatInput } from '@/components/webster/WebsterChatInput';
/**
 * Self-contained chat surface. Wraps the WebsterChatArea (message list +
 * streaming indicator) and the WebsterChatInput (textarea + send button),
 * and threads the live token counter through internally so parents pass
 * `chat` once instead of drilling streamedChars / confirmedTokens through
 * multiple layers of unrelated components.
 *
 * Both the LP builder editor panel and the email builder use this directly —
 * they only forward the `chat` object plus a few UI-specific prop overrides.
 */
export function WebsterChatPanel({ chat, onSend, disabled, lockedByUserName, emptyMessage, placeholder, buttonLabel, suggestThankYouGeneration, onGenerateThankYou, }) {
    return (_jsxs("div", { className: "flex-1 flex flex-col overflow-hidden", children: [_jsx(WebsterChatArea, { messages: chat.messages, generating: chat.generating, emptyMessage: emptyMessage, suggestThankYouGeneration: suggestThankYouGeneration, onGenerateThankYou: onGenerateThankYou }), _jsx(WebsterChatInput, { onSend: onSend, disabled: disabled, lockedByUserName: lockedByUserName, placeholder: placeholder, buttonLabel: buttonLabel })] }));
}
